import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';

export const YEAR_ONLY_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'YYYY',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  standalone: false,
  selector: 'app-year-filter',
  templateUrl: './year-filter.component.html',
  styleUrls: ['./year-filter.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: YEAR_ONLY_FORMATS }],
})
export class YearFilterComponent implements OnInit {
  @Input() label: string = '';
  @Input() customClass: string = '';
  @Input() styleType: string = 'squared';
  @Output() yearSelected = new EventEmitter<number>();

  yearFormControl = new FormControl();
  currentYear = null;

  ngOnInit() {
    this.initCurrentYear();
  }

  handleYearDatepickerValueChange(event = null, datepicker: any = null): void {
    this.currentYear = event?._i?.year.toString() ?? null;
    this.yearFormControl.setValue(this.currentYear);
    datepicker?.close();

    this.yearSelected.emit(this.currentYear);
  }

  initCurrentYear() {
    this.currentYear = new Date().getFullYear().toString();
    this.yearFormControl.setValue(this.currentYear);

    this.yearSelected.emit(new Date().getFullYear());
  }
}
